<template>
  <section class="tutorial-library">
    <h1 class="text-lg font-semibold mb-1">Video Tutorials</h1>
    <p class="tutorial-intro">Short walkthroughs to help you set up, manage and improve your account. Choose a guide to watch it here.</p>
    <label class="tutorial-search-label" for="tutorial-search">Find a tutorial</label>
    <input id="tutorial-search" v-model="search" type="search" class="tutorial-search" placeholder="Search prompts, phone numbers, lead rules…" />
    <div class="tutorial-filters" aria-label="Filter tutorials by topic">
      <button v-for="topic in topics" :key="topic" type="button" :aria-pressed="category === topic" :class="{ active: category === topic }" @click="category = topic">{{ topic }}</button>
    </div>
    <p class="tutorial-count" role="status">{{ filtered.length }} {{ filtered.length === 1 ? 'tutorial' : 'tutorials' }}</p>
    <div class="tutorial-grid">
      <article v-for="guide in filtered" :key="guide.id" class="tutorial-card">
        <span class="tutorial-topic">{{ guide.category }}</span>
        <h2>{{ guide.title }}</h2>
        <p>{{ guide.description }}</p>
        <video-guide :ids="guide.id" />
      </article>
    </div>
    <div v-if="!filtered.length" class="tutorial-empty">
      <p>No tutorials match your search.</p>
      <button type="button" @click="search = ''; category = 'All'">Clear filters</button>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import { videoGuides, legacyGuides } from '@/data/videoGuides';
export default {
  data: () => ({ search: '', category: 'All' }),
  computed: {
    ...mapState({ me: state => state.me.me, profile: state => state.me.profile }),
    guides() {
      return videoGuides.concat(legacyGuides).filter(guide => {
        if (guide.diyOnly && (!this.me || this.me.isDiy != 1)) return false;
        if (guide.id === 'referrals') return this.me && Number(this.me.parent_id) === 1353 && this.profile && this.profile.company_type === 'agency';
        return true;
      });
    },
    topics() { return ['All'].concat([...new Set(this.guides.map(guide => guide.category))]); },
    filtered() {
      const query = this.search.trim().toLowerCase();
      return this.guides.filter(guide => (this.category === 'All' || guide.category === this.category) && (guide.title + ' ' + guide.description).toLowerCase().includes(query));
    }
  }
};
</script>

<style scoped>
.tutorial-intro { color: #6b7280; font-size: 13px; margin-bottom: 20px; }
.tutorial-search-label { display: block; font-size: 12px; font-weight: 600; margin-bottom: 6px; }
.tutorial-search { width: 100%; max-width: 480px; padding: 9px 12px; font-size: 13px; border: 1px solid #d1d5db; border-radius: 4px; background: #fff; }
.tutorial-search:focus { outline: 2px solid #44468f; outline-offset: 2px; }
.tutorial-filters { display: flex; flex-wrap: wrap; gap: 8px; margin: 16px 0; }
.tutorial-filters button { font-size: 12px; padding: 6px 10px; border: 1px solid #e5e7eb; border-radius: 4px; color: #4b5563; background: #fff; }
.tutorial-filters button.active { border-color: #44468f; color: #44468f; background: #f5f5fa; }
.tutorial-count { color: #6b7280; font-size: 12px; }
.tutorial-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(260px, 1fr)); gap: 16px; }
.tutorial-card { display: flex; flex-direction: column; padding: 18px; border: 1px solid #e5e7eb; border-radius: 4px; background: #fff; }
.tutorial-topic { font-size: 11px; color: #6b7280; margin-bottom: 8px; }
.tutorial-card h2 { font-size: 14px; font-weight: 600; line-height: 1.5; color: #1f2937; margin-bottom: 8px; }
.tutorial-card p { font-size: 12px; line-height: 1.6; color: #6b7280; flex-grow: 1; margin-bottom: 16px; }
.tutorial-empty { padding: 30px 0; color: #6b7280; font-size: 13px; }
.tutorial-empty button { color: #44468f; }
@media (max-width: 340px) { .tutorial-grid { grid-template-columns: 1fr; } }
</style>
